module.exports = __webpack_public_path__ + "img/instagram.9afb09e3.svg";